//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Goldman_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Goldman_info.vue